// Mini reviews / rating section — sourced from FishingBooker listing facts.
import { Star } from "lucide-react";

const HEADLINES = [
  { quote: "Great family fishing trip — Captain and crew made our kids feel like real anglers.", who: "Family of four · 2024" },
  { quote: "Amazing time on board. We hooked into a marlin within the first hour and never stopped.",  who: "Returning charter guest · 2024" },
  { quote: "Great boat, great crew, great Captain. Hands-down the best charter day we've had in the Caribbean.", who: "Tournament angler · 2023" },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="aq-section aq-bg-foam">
      <div className="aq-container">
        <span className="aq-overline">Reviews</span>
        <div className="flex items-baseline flex-wrap gap-3 mt-4">
          <h2 className="aq-h2 text-3xl sm:text-4xl" style={{ color: "var(--aq-navy)" }}>
            4.8 / 5 · 53 reviews
          </h2>
          <div className="inline-flex items-center gap-0.5" aria-hidden>
            {[1,2,3,4,5].map((i) => (
              <Star key={i} size={18} fill="var(--aq-gold)" stroke="var(--aq-gold)" />
            ))}
          </div>
        </div>
        <span className="aq-divider" />

        <div className="grid md:grid-cols-3 gap-5 mt-8">
          {HEADLINES.map((h, i) => (
            <figure key={i} className="aq-card p-6" data-testid={`review-card-${i}`}>
              <div className="inline-flex gap-0.5" aria-hidden>
                {[1,2,3,4,5].map((j) => (
                  <Star key={j} size={14} fill="var(--aq-gold)" stroke="var(--aq-gold)" />
                ))}
              </div>
              <blockquote className="aq-serif text-lg mt-4" style={{ color: "var(--aq-navy)", lineHeight: 1.45 }}>
                "{h.quote}"
              </blockquote>
              <figcaption className="aq-overline mt-4" style={{ fontSize: 10 }}>{h.who}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
